<template>
  <el-dialog
    v-dialogDrag
    title="新增方案"
    :visible="visible"
    :close-on-click-modal="false"
    v-loading="dialogLoading"
    @close="handleClose"
    class="small-dialog"
    center
    :modal="false"
    :show-close="false"
  >
    <el-form :model="formData" label-width="160px" :rules="formRules" ref="formRef" class="mt-40px">
      <el-form-item label="序号" prop="seq">
        <el-input v-model="formData.seq" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model="formData.name" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="设备" prop="modelId">
        <el-select
          ref="selectTree"
          v-model="formData.modelId"
          placeholder="请选择"
          clearable
          filterable
          :popper-append-to-body="false"
        >
          <el-option
            v-for="item in sceneFlatData"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="场景" prop="ModelSceneType">
        <el-select
          ref="selectScene"
          v-model="formData.ModelSceneType"
          placeholder="请选择"
          clearable
          filterable
          :popper-append-to-body="false"
        >
          <el-option
            v-for="item in sceneData"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="简介" prop="remark">
        <el-input
          type="textarea"
          v-model="formData.remark"
          placeholder="请输入"
          :row="10"
          maxlength="200"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="save" :loading="saveLoading">确定</el-button>
      <el-button size="small" @click="handleClose">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { isNil, isEmpty, cloneDeep } from 'lodash'
import { ModelSceneApi } from '@wiz-api/scene-management'
import { EquipDisAssembleySolutionApi } from '@wiz-api/equipment-assembly-trainning'

const equipDisAssembleySolution = new EquipDisAssembleySolutionApi()
const modelSceneApi = new ModelSceneApi()
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        seq: '',
        name: '',
        modelId: '',
        ModelSceneType: '1',
        remark: '',
      },
      formRules: {
        name: { required: true, message: '请输入名称', trigger: 'blur' },
        modelId: { required: true, message: '请选择设备', trigger: 'blur' },
      },
      sceneFlatData: [],
      defaultTreeProps: {
        children: 'children',
        label: 'name',
      },
      dialogLoading: false,
      saveLoading: false,
      sceneData: [
        {
          id: '1',
          name: '室外',
        },
        {
          id: '2',
          name: '室内',
        },
      ],
    }
  },
  async created() {
    this.dialogLoading = true
    this.formData = this.$data.formData
    this.getSceneList()
    this.dialogLoading = false
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    async getSceneList() {
      const [err, res] = await modelSceneApi.getList({
        skipCount: 0,
        maxResultCount: 1000,
      })
      if (!err && !isNil(res)) {
        this.sceneFlatData = res.items
      }
    },
    // 保存
    save() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          if (this.formData.modelId) {
            const data = this.sceneFlatData.find((item) => { return item.id === this.formData.modelId })
            this.formData.modelName = data ? data.name : ''
          }
          const query = cloneDeep(this.formData)
          if (isEmpty(query.shortCutPicFileId)) {
            query.shortCutPicFileId = null
          }
          console.log(query)
          const [err, res] = await equipDisAssembleySolution.create({
            body: query,
          })
          if (!err && !isNil(res)) {
            this.$message.success({
              showClose: true,
              message: '保存成功！',
            })
            this.$emit('refresh')
            this.handleClose()
          }
          this.saveLoading = false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../css/index.scss';
</style>
